import { render, staticRenderFns } from "./AudioTitleComponent.vue?vue&type=template&id=2ea1cd04&scoped=true"
import script from "./AudioTitleComponent.vue?vue&type=script&lang=js"
export * from "./AudioTitleComponent.vue?vue&type=script&lang=js"
import style0 from "./AudioTitleComponent.vue?vue&type=style&index=0&id=2ea1cd04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea1cd04",
  null
  
)

export default component.exports